export default "__VITE_ASSET__BmvJzNVf__"